module.exports = __webpack_public_path__ + "static/media/PC_Carrosel_NOSQL.47f38e75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/NoSQL/PC_Carrosel_NOSQL.png
// module id = 193
// module chunks = 0